// extracted by mini-css-extract-plugin
export default {"login":"LoginButton_login__2iFx3","button":"LoginButton_button__tRLDr"};